'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var notificationBadge = {
  bindings: {
    count: '='
  },
  template: '<span ng-if="$ctrl.count > 0" class="badge badge-assertive">{{ $ctrl.count }} </span>'
};

exports.default = notificationBadge;


/** WEBPACK FOOTER **
 ** ./src/app/directives/notifications/notificationBadge.js
 **/